import { findIntersectionsBetweenSets } from '@anecdotes/utils';
import { Dictionary } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { createPartitionStateSelector } from '../create-partition-state/create-partition-state.selector';
import { SortSelectors } from '../sort';

export function selectorBody(
  dataToFilter: Dictionary<any>,
  isEmptyState: boolean,
  filteredDataIds: string[],
  searchFilteredDataIds: string[],
  sortedIds: string[]
): any {
  if (!filteredDataIds || isEmptyState) {
    return [];
  }

  const filteredDataIdsSet = new Set(filteredDataIds);
  
  const idsToFindIntersections: Set<string>[] = [filteredDataIdsSet];

  if (searchFilteredDataIds) {
    idsToFindIntersections.push(new Set(searchFilteredDataIds));
  }
  
  const resolvedSet = findIntersectionsBetweenSets(idsToFindIntersections);

  return sortedIds
    .filter((dataId) => resolvedSet.has(dataId) && dataId in dataToFilter)
    .map((dataId) => dataToFilter[dataId])
    .filter((item) => item);
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createFilteredDataSelector = (filterInstanceId: string) =>
  createSelector(
    createPartitionStateSelector(filterInstanceId),
    SortSelectors.createOrderedDataIdsSelector(filterInstanceId),
    (partitionState, sortedIds) => {
      return selectorBody(
        partitionState?.filterState.dataToFilter,
        partitionState?.filterState.isEmptyState,
        partitionState?.filterState.filteredDataIds,
        partitionState?.searchState.searchFilteredDataIds,
        sortedIds
      );
    }
  );
